import React from 'react';
import PortActivationBadge from './PortActivationBadge';
import { activationEntryFromBatchStatus } from './parseActivityRows';

/** Activation status badge for batch SMS queue items */
export default function BatchActivationBadge({ status }) {
  return (
    <PortActivationBadge
      statusEntry={activationEntryFromBatchStatus(status)}
      compact
      showTrafficLight={false}
    />
  );
}
